import React, {useState} from "react";
import {Button, Card, Form} from "react-bootstrap";
import {useSelector} from "react-redux";
import parseNoteFromApi from "../../helpers/parse_note_from_api";

const EditNoteComponent = ({note, setAction, setNotes}) => {
  const state = useSelector((state) => {
    return {
      organizationName: state.organization.name,
      affiliateMemberId: state.affiliateMember.id,
    }
  });
  const [editNoteBody, setEditNoteBody] = useState(note.body);

  const handleUpdate = () => {
    const {organizationName, affiliateMemberId} = state;
    $.ajax({
      url: `/organizations/${organizationName}/affiliate_members/${affiliateMemberId}/notes/${note.id}.json`,
      method: "PATCH",
      data: {
        note: {
          body: editNoteBody,
        }
      },
      success: (data) => {
        const newNote = parseNoteFromApi(data, note);
        setNotes((notes) => {
          return notes.map((note) => {
            if (note.id === newNote.id) {
              return newNote;
            } else {
              return note;
            }
          })
        })
        setAction("show");
      }
    });
  }

  const handleDelete = () => {
    const {organizationName, affiliateMemberId} = state;
    $.ajax({
      url: `/organizations/${organizationName}/affiliate_members/${affiliateMemberId}/notes/${note.id}.json`,
      method: "DELETE",
      success: () => {
        setNotes((notes) => {
          return notes.filter((listNote) => {
            return listNote.id !== note.id;
          })
        })
      }
    });
  }

  return (
    <Card>
      <div
        className="card-block"
        style={{
          backgroundColor: "white",
        }}
      >
        <div className="col-12">
          <Form.Control
            as="textarea"
            value={editNoteBody}
            onChange={(e) => setEditNoteBody(e.target.value)}
            className="mb-xs-0 mb-lg-2 col-12"
          />
        </div>
        <div className="d-flex justify-content-between col-12 pt-2">
          <div>
            <Button
              size="sm"
              variant="outline-danger"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </div>
          <div>
            <Button
              size="sm"
              variant="outline-info"
              className="mr-2"
              onClick={() => setAction("show")}
            >
              Cancel
            </Button>
            <Button
              size="sm"
              variant="info"
              className=""
              disabled={editNoteBody === note.body || editNoteBody === ""}
              onClick={handleUpdate}
            >
              Update
            </Button>
          </div>
        </div>
      </div>
    </Card>
  );
}

export default EditNoteComponent;
